import "./Loader.scss";
export const Loader = () => {
  return (
    <>
      <div className="container">
        <div className="📦"></div>
        <div className="📦"></div>
        <div className="📦"></div>
        <div className="📦"></div>
        <div className="📦"></div>
      </div>
    </>
  );
};
